import * as LDClient from 'launchdarkly-js-client-sdk';

export default defineNuxtPlugin(async nuxtApp => {
  const clientSideId = useRuntimeConfig().public.launchDarklyClientSideId;

  let client = null;
  let initializationPromise = null;

  const initializeLDClient = async () => {
    if (initializationPromise) return initializationPromise;

    initializationPromise = (async () => {
      try {
        const {data} = await apiUseFetch('/orgs');

        if (data && data.value && data.value.id) {
          const context = {
            kind: 'organization',
            key: data.value.id,
            name: data.value.name,
          };

          client = LDClient.initialize(clientSideId, context);
          try {
            await client.waitForInitialization();
          } catch (error) {
            console.error('Failed waiting for LaunchDarkly client to initialize:', error);
            return null;
          }
        } else {
          throw new Error('Unable to initialize LaunchDarkly: No organization data');
        }
      } catch (error) {
        console.error('Error initializing LaunchDarkly client:', error);
        return null;
      }
    })();

    return initializationPromise;
  };

  const getClient = async () => {
    try {
      if (!client) {
        await initializeLDClient();
      }
      return client;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[LaunchDarkly] Error in getClient:', err);
      throw err;
    }
  };

  return {
    provide: {
      ldClient: new Proxy(
        {},
        {
          get: (target, prop) => {
            return async (...args) => {
              try {
                const ldClient = await getClient();
                if (!ldClient) {
                  throw new Error('LaunchDarkly client is not initialized');
                }
                return ldClient[prop](...args);
              } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`[LaunchDarkly] Error calling method "${prop}":`, err);
                throw err;
              }
            };
          },
        }
      ),
    },
  };
});
